// Generated by CoffeeScript 2.7.0
var channels;

import {
  SubscriptionsChannel
} from './subscriptions_channel.js';

import {
  UsersChannel
} from './users_channel.js';

if (!(_cargo && _cargo.disable_cable)) {
  if (Push.supported) {
    channels = {SubscriptionsChannel, UsersChannel};
    Skylark.Cable = ActionCable.createConsumer();
    Skylark.Channels = {};
    _.each(channels, function(mixin, channel_name) {
      return Skylark.Cable.subscriptions.create(channel_name, mixin);
    });
  }
}
